// extracted by mini-css-extract-plugin
export default {"container":"History_container__l18m1","link":"History_link__uOQ-6","current":"History_current__YQqwf"};